module.exports = __webpack_public_path__ + "static/img/0001.5a4c457.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/0001.jpg
// module id = U+SR
// module chunks = 1